module.exports = __webpack_public_path__ + "img/case-ct_pacecapsule_side.c5565c9.png";